import { TextCodes } from '@api/types/translation/TextCodes';
import { CartLineItem, LineItemPlaceholder } from '@components/common';
import { useCartContext } from '@context/CartContext';
import { Alert } from '@mui/material';
import Box from '@mui/material/Box';
import { t } from '@translations';

export const CartContent = () => {
  const { isWorking, isEmpty, cartItems } = useCartContext();
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoRows: '1fr',
        gap: 2,
      }}
    >
      {isWorking &&
        Array.from({ length: 5 }).map((_, index) => <LineItemPlaceholder key={index} />)}
      {isEmpty && <Alert severity='info'>{t(TextCodes.Product.Cart.Empty)}</Alert>}
      {cartItems?.map((item) => (
        <CartLineItem lineItem={item} key={item.code} isEditable={true} />
      ))}
    </Box>
  );
};
